import { render, staticRenderFns } from "./EmailPreferencesSectorBulkSelector.vue?vue&type=template&id=70e2bfec&"
import script from "./EmailPreferencesSectorBulkSelector.vue?vue&type=script&lang=js&"
export * from "./EmailPreferencesSectorBulkSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports